import React, { Component } from "react";
import axios, { CancelToken } from "axios";

import { Translate } from "react-redux-i18n";

import StatsRow from "./StatsRow";
import Graph from "./Graph";
import Sessions from "./Sessions";

import "../../../styles/components/insights/statistics/InsightsBy.scss";
import graph from "../../../styles/images/graph_grey.svg";
import "../../../styles/utils/_loadingScreen.scss";

class InsightsByEV extends Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.fetchInsights();
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps?.from !== this.props.from || prevProps?.to !== this.props.to)
      this.props.fetchInsights();
  }

  render() {
    return (
      <div id="insightsByEV">
        {!this.props.loading ? (
          <>
            <StatsRow type="ev" data={this.props.data} />
            <div id="graph" className="highlight-container">
              <div className="highlight-container-header">
                <img src={graph} alt="" />
                <Translate value="insights_statistics" />
              </div>
              <div className="highlight-container-body">
                {this.props.data ? (
                  <Graph data={this.props.data} from={this.props.from} to={this.props.to} />
                ) : (
                  <Translate value="insights_noData" />
                )}
              </div>
            </div>
            <Sessions
              mode="ev"
              sessionCount={this.props.data?.sessions || 0}
              from={this.props.from}
              to={this.props.to}
              evId={this.props.evId}
              driverId={this.props.driverId}
            />
          </>
        ) : (
          <div className="loading-container">
            <div className="loading-spinner">
              <div className="generic-loading">
                <div></div>
                <div></div>
              </div>
            </div>
          </div>
        )}
      </div>
    );
  }
}

export default InsightsByEV;
